import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import BlockTypes, { MUTABLE_BLOCKS } from '../../types/BlockTypes';
import { normalizeNode, shouldNotBeEmpty, shouldBeAtRoot, shouldMergeWithSimilarSiblings, shouldHaveChildrenOfType } from '../utils/NormalizationHelper';
import renderBlocks from '../utils/renderBlocks';
import makeMarkdownBlockShortcut from '../utils/makeMarkdownBlockShortcut';
import makeKeyboardBlockShortcut from '../utils/makeKeyboardBlockShortcut';
import makeToolbarButton, { EXPANDED_SELECTION, BASIC_INSERTION, EXPANDED_INSERTION } from '../utils/makeToolbarButton';
import { InfoIcon } from '../../components/Icons';
import Hint from './components/Hint';

function siblingsComparator(a, b) {
  return a.type === b.type && a.getIn(['nodes', 0, 'data', 'color']) === b.getIn(['nodes', 0, 'data', 'color']);
}

export var normalizer = normalizeNode(BlockTypes.HINTS, [shouldNotBeEmpty, shouldBeAtRoot, [shouldMergeWithSimilarSiblings, siblingsComparator], [shouldHaveChildrenOfType, BlockTypes.HINT]]);
export default (function () {
  var _html, _renderBlocks;

  return [normalizer, {
    serializers: {
      html: (_html = {}, _defineProperty(_html, BlockTypes.HINTS, 'div'), _defineProperty(_html, BlockTypes.HINT, 'p'), _html),
      markdown: _defineProperty({}, BlockTypes.HINT, function (_ref) {
        var children = _ref.children;
        return "!! ".concat(children, "\n");
      })
    }
  }, renderBlocks((_renderBlocks = {}, _defineProperty(_renderBlocks, BlockTypes.HINTS, function (props) {
    return React.createElement("div", props.attributes, React.createElement(Hint, {
      editor: props.editor,
      node: props.node,
      readOnly: props.readOnly
    }, props.children));
  }), _defineProperty(_renderBlocks, BlockTypes.HINT, function (props) {
    return React.createElement("div", props.attributes, props.children);
  }), _renderBlocks)), makeToolbarButton(BlockTypes.HINT, {
    icon: InfoIcon,
    title: 'Hint',
    visibility: EXPANDED_SELECTION | BASIC_INSERTION | EXPANDED_INSERTION,
    canApply: function canApply(editor) {
      return editor.isActiveBlock(MUTABLE_BLOCKS);
    },
    isActive: function isActive(editor) {
      return editor.isActiveBlock(BlockTypes.HINT);
    },
    onApply: function onApply(editor) {
      return editor.toggleBlock(BlockTypes.HINT);
    }
  }), makeMarkdownBlockShortcut(/^(!!)$/, BlockTypes.HINT), makeKeyboardBlockShortcut('mod+shift+option+h', BlockTypes.HINT)];
});